import { IUser } from "../../../../types/user/iuser.interface";
import { TRow } from "../listing-table.types";
import { useListingTableRenderComponentsStyles } from "./listing-table-render-components.styles";
import { Avatar } from "@material-ui/core";
import React from "react";

export const UserNameAvatar = (user: IUser | TRow) => {
  const classes = useListingTableRenderComponentsStyles();
  const userName = `${user?.firstName} ${user?.lastName}`;
  return (
    <div className={classes.avatarWithName}>
      <Avatar title={userName} alt={userName} src={user?.profileImageUrl} />
      {userName}
    </div>
  );
};
